import React from 'react';
import { pagination } from './commonInterface';
import TablePagination from './TablePagination';

const PaginationLayout: React.FC<pagination> = ({ count, data, page, limit }) => {
  return (
    <TablePagination
      count={count}
      data={data}
      page={page}
      limit={limit}
      showDetails={true}
    />
  );
};

export default PaginationLayout;